export interface ICheckOffContractRequest {
    dokumentId?: string;
    kontraktId?: string;
    kontraktlinjeIds?: Array<string>;
    kommentar?: string;
    skalRegistreres?: boolean;
    fullfor?: boolean;
}
export class CheckOffContractRequest implements ICheckOffContractRequest {
    public dokumentId?: string;
    public kontraktId?: string;
    public kontraktlinjeIds?: Array<string>;
    public kommentar?: string;
    public skalRegistreres?: boolean;
    public fullfor?: boolean;

    public constructor(params: ICheckOffContractRequest) {
        Object.assign(this, params);
    }
}
